module.exports = __webpack_public_path__ + "static/img/4areaB_1.3c1f0ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_1.png
// module id = 1173
// module chunks = 1